import React, { memo, useEffect, useState } from "react";
import { Button } from "components/Buttons";
import { ButtonColorScheme, ButtonType } from "types/ui";

type Props = {
  showModal: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  headerText: string;
  bodyText: string;
};
export const RemoveNoteModal = memo(
  ({ showModal, onConfirm, onClose, headerText, bodyText, loading }: Props) => {
    const [disabled, setDisabled] = useState(false);

    const handleConfirm = () => {
      setDisabled(true);
      onConfirm();
    };
    useEffect(() => {
      setDisabled(false);
    }, [showModal]);
    return (
      <>
        {showModal ? (
          <>
            <div className="justify-center items-center flex fixed inset-0 outline-none focus:outline-none z-50">
              <div className="relative w-auto my-6 mx-auto">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                    <h2 className="font-semibold">{headerText}</h2>
                  </div>
                  <div className="relative px-4 pb-4 max-w-2xl flex-auto">
                    <p className="my-4 text-blueGray-500  leading-relaxed">
                      {bodyText}
                    </p>
                  </div>
                  {loading && (
                    <div className="flex items-center justify-center w-full h-full absolute overflow-hidden bg-bgLight/50 ">
                      <div className="spinner" />
                    </div>
                  )}
                  <div className="flex items-center space-x-2 justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                    <Button
                      title="Cancel"
                      onClick={onClose}
                      type={ButtonType.text}
                      colorScheme={ButtonColorScheme.danger}
                    />
                    <Button
                      title="Confirm"
                      onClick={handleConfirm}
                      colorScheme={
                        disabled
                          ? ButtonColorScheme.disabled
                          : ButtonColorScheme.primary
                      }
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black" />
          </>
        ) : null}
      </>
    );
  }
);
